import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAgahFundsPageLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width={38}
    height={38}
    fill='none'
    {...props}
  >
    <path
      fill='url(#agahFundsPageLogo_svg__a)'
      stroke='#E0E3EB'
      d='M37.5 19c0 10.217-8.283 18.5-18.5 18.5S.5 29.217.5 19 8.783.5 19 .5 37.5 8.783 37.5 19Z'
    />
    <defs>
      <pattern
        id='agahFundsPageLogo_svg__a'
        width={1}
        height={1}
        patternContentUnits='objectBoundingBox'
      >
        <use xlinkHref='#agahFundsPageLogo_svg__b' transform='scale(.00162)' />
      </pattern>
      <image
        xlinkHref='/images/icons/agah-funds-page-logo-208b979b.webp'
        id='agahFundsPageLogo_svg__b'
        width={619}
        height={619}
      />
    </defs>
  </svg>
);
export default SvgAgahFundsPageLogo;
